import ReactGA from "react-ga4";

const DEFAULT_GA_MEASUREMENT_ID = "G-H47X01Y2P6";
const GA_MEASUREMENT_ID = (
  process.env.REACT_APP_GA_MEASUREMENT_ID || DEFAULT_GA_MEASUREMENT_ID
).trim();

const isProduction = process.env.NODE_ENV === "production";
let isInitialized = false;

export const isAnalyticsEnabled = isProduction && Boolean(GA_MEASUREMENT_ID);

export const initializeAnalytics = () => {
  if (!isAnalyticsEnabled || isInitialized) {
    return;
  }

  ReactGA.initialize(GA_MEASUREMENT_ID);
  isInitialized = true;
};

export const trackPageView = (pagePath) => {
  if (!isAnalyticsEnabled || !isInitialized || !pagePath) {
    return;
  }

  ReactGA.send({ hitType: "pageview", page: pagePath });
};
